<template lang="pug">
  main
    NavBarTransportes
    Loader(v-show="isLoading")
    ModalDelete(v-show="modalStatus" :title="titleModal" :content="contentModal" @padre:eliminar="eliminarSalida")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Detalle de consumo de Combustible
              | &nbsp
              a.button.is-black.is-rounded(@click="backToPage")
                i.fas.fa-times
        .columns
          .column.is-2
            .field
              .control
                flat-pickr(
                  v-model='fechaSalida'
                  :config="config"
                  class="input"
                )
          .column(:class="userNormal ? 'is-4 is-offset-4' : 'is-2'")
            .field
              .control
                input.input.is-dark(
                  type='text', 
                  placeholder='Buscar por Usuario| Cantidad | Fecha ',
                  v-model="query",
                )
          .column.is-5(v-show="!userNormal")
            input#allH.is-checkradio.is-black(type='radio', value='ALL' v-model='filter' checked='checked')
            label.is-size-6(for='allH') Todos
            input#tpaH.is-checkradio.is-black(type='radio', value='TPA' v-model='filter')
            label.is-size-6(for='tpaH') TPA
            input#irgeH.is-checkradio.is-black(type='radio', value='IRGE' v-model='filter')
            label.is-size-6(for='irgeH') IRGE
            input#corpH.is-checkradio.is-black(type='radio', value='CORP' v-model='filter')
            label.is-size-6(for='corpH') CORP.
            input#ductoH.is-checkradio.is-black(type='radio', value='DUCTO' v-model='filter')
            label.is-size-6(for='ductoH') DUCTO
          .column.is-1
            a.button.is-success.is-rounded.is-small(@click="descargarSalidas")
              span.icon.is-small
                i.fas.fa-download
              span Salidas
          .column.is-1
            router-link.a.button.is-black.is-small.is-rounded(to="/Transportes/Combustible/Salidas/Nueva")
              | Nueva 
        .columns(v-show="result_query != ''")
          .column.is-offset-8.is-4
            span.tag.is-black.is-small {{ result_query }}
        .columns
          .column.is-12
            Tb_Salidas(:salidas="salidasShow" @reloadTable="reloadTable" @eliminarSalida="verModalEliminar")
        .columns.column-blanco
</template>

<script>
  import NavBarTransportes from './layout/NavBarTransportes.vue'
  import Loader from '@/components/shared/Loader.vue'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import InventarioServices from '@/services/inventario/inventario'
  import Tb_Salidas from './componentes/Tb_Salidas.vue'
  import ModalDelete from '@/components/shared/ModalDelete.vue'
  import moment from 'moment'
  import { mapState } from 'vuex'

  export default {
    name: 'Salidas',
    components: { NavBarTransportes, Loader, flatPickr, Tb_Salidas, ModalDelete },
    data() {
      return {
        isLoading: true,
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m',
          altInput: true,
          dateFormat: 'Y-m',
          locale: Spanish, // locale for this instance only          
        },
        fechaSalida: moment().format('YYYY-MM'),
        salidas: [],
        salidasShow: [],
        modalStatus: '',
        titleModal: '',
        contentModal: '',
        salidaSelect: {},
        query: '',
        filter: 'ALL',
        result_query: '',
        userNormal: true
      }
    },
    watch: {
      fechaSalida() {
        this.obtenerSalidas()
      },
      query() {
        const QUERY_ARTICULOS = this.query.toUpperCase()
        if (this.query.length !== 0) {
          const salidasFilter = this.salidas.filter( salida => { 
            return `${salida.fechaReg} ${salida.nombre_usuario} ${salida.placaV} ${salida.categoriaV}`.toUpperCase().includes(QUERY_ARTICULOS)
          }) 
          this.salidasShow = salidasFilter
          this.result_query = this.salidasShow.length === 1 ? `Se encontró ${this.salidasShow.length} coincidencia.` : `Se encontraron ${this.salidasShow.length} coincidencias.`
        } else {
          this.salidasShow = this.salidas
          this.result_query = ''
        }
      },
      filter() {
        if (this.filter !== '') {
        console.log('filter')
          if (this.filter === 'ALL') {
            this.salidasShow = this.salidas
          } else {
            let salidasFilter = []
            switch (this.filter) {
              case 'DUCTO':
                salidasFilter = this.salidas.filter( (tarjet) => tarjet.ubicacion === 'EB00' || tarjet.ubicacion === 'EB01' || tarjet.ubicacion === 'EB02' || tarjet.ubicacion === 'EB03' || tarjet.ubicacion === 'EB04' || tarjet.ubicacion === 'ERM' || tarjet.ubicacion === 'LPG_DUCTO')
                this.salidasShow = salidasFilter
                break
              case 'TPA':
                salidasFilter = this.salidas.filter( (tarjet) => tarjet.ubicacion === 'TPA')
                this.salidasShow = salidasFilter
                break
              case 'CORP':
                salidasFilter = this.salidas.filter( (tarjet) => tarjet.ubicacion === 'CORP')
                this.salidasShow = salidasFilter
                break
              case 'IRGE':
                salidasFilter = this.salidas.filter( (tarjet) => tarjet.ubicacion === 'IRGE')
                this.salidasShow = salidasFilter
                break
              default:
                this.salidasShow = this.salidas
                break
            }
          }
        }
      }
    },
    methods: {
      iniciarComponente() {
        if (this.userLogin.cargo === '000' || this.userLogin.cargo === '002' || this.userLogin.cargo === '2100' || this.userLogin.cargo === '121' || this.userLogin.cargo === '210' || this.userLogin.cargo === '230' || this.userLogin.cargo === '323' || this.userLogin.cargo === '324') {
          this.userNormal = false
        }
        this.obtenerSalidas()
      },
      obtenerSalidas() {
        let ubi = this.userNormal ? this.userLogin.ubicacion : 'ALL'
        InventarioServices.getComb_Salidas(this.fechaSalida, ubi, this.userLogin.cargo)
          .then((data) => {
            console.log(data)
            this.salidas = data
            this.salidasShow = this.salidas
          })
          .catch((e) => console.log(e))
        this.isLoading = false
      },
      reloadTable (val) {
        if (val) {
          this.obtenerSalidas()
        }
      },
      verModalEliminar(salida) {
        this.salidaSelect = salida
        this.titleModal = 'Eliminar Salida'
        this.contentModal = `¿Desea eliminar la salida del ${this.salidaSelect.fecha_salida}?`
        this.modalStatus = true
      },
      eliminarSalida(value) {
        console.log(value)
        console.log(this.salidaSelect)

        if ( value === 'delete') {
          InventarioServices.deleteComb_salida(this.salidaSelect.id)
            .then((data)=> {
              console.log(data)
              this.mostrarDisplay(data.respuesta, 'done', 'Ok')
              this.obtenerSalidas()
            })
            .catch((e)=> {console.log(e)})
        }
        this.titleModal = ''
        this.contentModal = ''
        this.modalStatus = false
      },
      descargarSalidas () {

      },
      mostrarDisplay(mensaje, icon, textButton) {
        let toast = this.$toasted.show(mensaje, {
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : textButton,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      backToPage () {
        this.$router.back()
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin'])
    }
  }
</script>

<style lang="scss" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/Salidas.vue